import { render, staticRenderFns } from "./cityAddAndUpdateDialog.vue?vue&type=template&id=5641b6ee&scoped=true&"
import script from "./cityAddAndUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./cityAddAndUpdateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5641b6ee",
  null
  
)

export default component.exports